export default {
  title: 'Admin',
  signOut: 'Sign out',
};
